import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'contabilidad/clasificaciones-de-fuentes-de-financiamiento-interna/';
export const baseURIUnion = 'contabilidad/clasificaciones-de-fuentes-de-financiamiento/';

/**
 * GET centros-de-costos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCFFInterna = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Fuentes de financiamiento generales (seleccionable: false)
 * unidas con las internas de la entidad (seleccionable: true)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCFFUnion = async (params) => {
  try {
    const response = await API.get(baseURIUnion, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
